import * as Case from "case";
import { ImageComponent } from '~contentful/components/image/image.component';
import { ComponentModel } from '~contentful/models/components/component.model';
import { AssetModel } from '~contentful/models/core/asset.model';

export class ImageModel extends ComponentModel {
  public readonly name: string;
  public readonly image: AssetModel;
  public readonly width?: number;
  public readonly height?: number;
  public readonly style?: any;
  public readonly componentClass = ImageComponent;

  public get contextLabel() {
    return this.name;
  }

  public get contextValue() {
    return Case.kebab(this.name);
  }
}
